import { lazyPipe, validateApiResponse, withApiErrorCapture } from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';

/** 모집형 4탭 카운트 — spec CountMyRecruitmentCampaignsV2Response (camelCase) */
const GetSeedingMeRecruitmentCountResponseDataSchema = z
  .object({
    /** 신청 탭 카운트 */
    pending: z.number().nonnegative(),
    /** 진행 탭 카운트 */
    confirmed: z.number().nonnegative(),
    /** 완료 탭 카운트 */
    completed: z.number().nonnegative(),
    /** 미선정 탭 카운트 */
    notSelected: z.number().nonnegative(),
  })
  .describe('GetSeedingMeRecruitmentCountResponseDataSchema');

const GetSeedingMeRecruitmentCountResponseSchema = createApiResponseSchema(
  GetSeedingMeRecruitmentCountResponseDataSchema,
);

export type GetSeedingMeRecruitmentCountResponse = z.infer<
  typeof GetSeedingMeRecruitmentCountResponseSchema
>;

export const getSeedingMeRecruitmentCount = withApiErrorCapture(
  lazyPipe(
    async (): Promise<GetSeedingMeRecruitmentCountResponse> =>
      executeStandardRequest(async () => {
        const response = await privateHttpClient.get<GetSeedingMeRecruitmentCountResponse>(
          urlJoin(campaignsApiPath.getSeedingMeRecruitmentCount),
        );
        return response;
      }),
    validateApiResponse(GetSeedingMeRecruitmentCountResponseSchema),
  ),
);
